import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Login from '../views/Login'
import Users from '../views/Users'
import UserDetails from '../views/UserDetails'
import Notifications from '../views/Notifications'
import Logout from '../views/Logout'
import ChangePassword from '../views/ChangePassword'
import FactoringCompanies from '../views/FactoringCompanies'
import FactoringCompanyDetail from '../views/FactoringCompanyDetail'
// import MasterImporter from '../views/MasterImporter'
import CompaniesMassiveUpdate from '../views/CompaniesMassiveUpdate'
import ForgotPassword from '../views/ForgotPassword'
import ResetPassword from '../views/ResetPassword'
import RugGuaranteesToBlu from '../views/rugGuaranteeToBlu/List'
import RugGuaranteeToBluDetail from '../views/rugGuaranteeToBlu/Detail'
import ImportLocations from '../views/ImportLocations'
import RedecoComplaintList from '../views/Complaints/Redeco/List'
import RedecoComplaintDetails from '../views/Complaints/Redeco/Detail'
import ReuneComplaintList from '../views/Complaints/Reune/List'
import ReuneComplaintDetails from '../views/Complaints/Reune/Detail'
import Sepomex from '../views/SepomexImporter'
import RoleManagement from '../views/RoleManagement'
import Zones from '../views/Zones'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/userDetails/:userId',
        name: 'userDetails',
        component: UserDetails
    },
    {
        path: '/settings/empresas-dragon',
        name: 'empresasDragon',
        component: FactoringCompanies
    },
    {
        path: '/settings/empresa-dragon-detail/:id?',
        name: 'empresasDragonDetails',
        component: FactoringCompanyDetail
    },
    {
        path: '/settings/rug/rug-guarantees-to-blu',
        name: 'rugGuaranteeToBluList',
        component: RugGuaranteesToBlu
    },
    {
        path: '/settings/rug/guarantee-to-blu/:id?',
        name: 'rugGuaranteeToBluDetail',
        component: RugGuaranteeToBluDetail
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout
    },
    {
        path: '/users',
        name: 'users',
        component: Users
    },
    {
        path: '/changePassword',
        name: 'changePassword',
        component: ChangePassword
    },
    {
        path: '/notifications',
        name: 'Notifications',
        component: Notifications
    },
    // {
    //     path: '/masterImporter',
    //     name: 'MasterImporter',
    //     component: MasterImporter
    // },
    {
        path: '/sepomex',
        name: 'sepomex',
        component: Sepomex
    },
    {
        path: '/settings/empresas-dragon/import',
        name: 'CompaniesMassiveUpdate',
        component: CompaniesMassiveUpdate
    },
    {
        path: '/forgotPassword',
        name: 'ForgotPassword',
        component: ForgotPassword
    },
    {
        path: '/resetPassword/:id/:token',
        name: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: '/Profile',
        name: 'Profile',
        redirect: '/changePassword'
    },
    {
        path: '/importLocations',
        name: 'ImportLocations',
        component: ImportLocations
    },
    {
        path: '/complaints/redeco',
        name: 'RedecoComplaintList',
        component: RedecoComplaintList
    },
    {
        path: '/complaints/redeco/details/:id?',
        name: 'RedecoComplaintDetail',
        component: RedecoComplaintDetails
    },
    {
        path: '/complaints/reune',
        name: 'ReuneComplaintList',
        component: ReuneComplaintList
    },
    {
        path: '/complaints/reune/details/:id?',
        name: 'ReuneComplaintDetail',
        component: ReuneComplaintDetails
    },
    {
        path: '/roles',
        name: 'RoleManagement',
        component: RoleManagement
    },
    {
        path: '/zones',
        name: 'Zones',
        component: Zones
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
